/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Csv_Ref_N2Inputs */

const en_to_csv_ref_n2 = /** @type {(inputs: To_Csv_Ref_N2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quoted because of the comma, which would otherwise split the field.`)
};

const ko_to_csv_ref_n2 = /** @type {(inputs: To_Csv_Ref_N2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`쉼표 때문에 인용됩니다. 인용하지 않으면 필드가 쪼개집니다.`)
};

const ja_to_csv_ref_n2 = /** @type {(inputs: To_Csv_Ref_N2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カンマのため引用されます。引用しないとフィールドが分割されます。`)
};

/**
* | output |
* | --- |
* | "Quoted because of the comma, which would otherwise split the field." |
*
* @param {To_Csv_Ref_N2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_csv_ref_n2 = /** @type {((inputs?: To_Csv_Ref_N2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Csv_Ref_N2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_csv_ref_n2(inputs)
	if (locale === "ko") return ko_to_csv_ref_n2(inputs)
	return ja_to_csv_ref_n2(inputs)
});